import React, { useEffect, useState } from "react"
import { makeStyles, Theme, createStyles, Grid, Paper } from "@material-ui/core"
import LoginPage from "./Login"

import ForgotPassword from "./ForgotPassword"
import ChangePassword from "./ChangePassword"
import Register from "./Register"
import { Redirect, useHistory, useLocation } from "react-router"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "left",
      color: theme.palette.text.secondary,
    },
  })
)
function CommonUnAuth(props: any) {
  let location: any = useLocation()
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="flex-start"
      >
        <Grid item xs={12} sm={6}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            style={{
              height: "100vh",
              background:
                "linear-gradient(211deg, rgb(7, 127, 131) 40%, rgb(1, 76, 78) 100%) transparent",
            }}
          >
            <img src="../../../assets/images/leftloginlogo.png" alt="logo" />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid
            container
            direction="row"
            justify="center"
            alignItems="center"
            style={{ height: "100vh" }}
          >
            <Grid item xs={12} sm={8}>
              {location.pathname == "/auth/forgotPassword" ? (
                <ForgotPassword />
              ) : location.pathname === "/auth/login" ? (
                <LoginPage />
              ) : location.pathname === "/auth/register" ? (
                <Register />
              ) : location.pathname === "/auth/ChangePassword" ? (
                <ChangePassword />
              ) : location.pathname === "/" ? (
                <Redirect to={"/auth/login"} />
              ) : null}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  )
}

export default CommonUnAuth
